(function($) {  
  function ProductColorSplit() {
    function applyColorSplit() {
      var isCollectionPage = $('.template-collection').length !== 0;
      var $groups = isCollectionPage ? $('.modal--is-active .group') : $('.group');
      $groups.each(function() {
        var $group = $(this);
        var $swatch_wrapper = $group.closest('.variant-wrapper');
        var colors = $group.data('colors').split(',');
        //console.log($group, colors);

        colors.forEach(function(color) {
          var $color = $swatch_wrapper.find('.variant-input[data-value="' + color + '"]');
          //console.log(color, $color);
          $group.find('.group-colors').append($color);
        });
      });      
      
      if ($groups.length) {
        var $color_wrap = $('.variant-input-wrap[data-handle="color"]');
        $color_wrap.append($('.color-groups-wrap'));
        $color_wrap.closest('.variant-wrapper').removeClass('visually-hidden');      
      }
    }
    
    // pdp
    applyColorSplit();
    
    // quickshop
    document.addEventListener('modalOpen', function(e) {
      setTimeout(applyColorSplit, 1000);
    });
  }
  
  function CartPrice() {
    let updateCartTotal = () => {
      utils.getCart().then(cart => {
        var cart_total_price = cart.total_price;
        if (theme.settings.enable_vat_pricing) {
          cart_total_price *= theme.settings.vat_price_modifier;
        }
        
        $('.cart-total').remove();
        $('[data-subtotal]').after('<span class="cart-total">' + utils.formatMoney(cart_total_price) + '</span>');
      });
    }
    document.addEventListener('ajaxProduct:added', (e) => {
      updateCartTotal();
    });
    document.addEventListener('cart:updated', (e) => {
      updateCartTotal();
    });
  }
  
  function TileHeights() {
    function SetTileHeight() {
      var $productItem = $('.grid-product .grid-product__content');
      $('.tile-wrap').css('height', $productItem.height());
    }
    
    $(window).on('resize', (e) => {
      setTimeout(SetTileHeight, 250);
    });
  }

  function CustomNewsletterModal() { 
    var selector_modal = '#NewsletterPopup-custom-newsletter-modal';
    var $modal = $(selector_modal);
    var daysBeforeReappear = $modal.data('delay-days');

    $(document).on('submit', `${selector_modal} form`, function (e) {
      var $form = $(e.currentTarget);
      setTimeout(function () {
        var formHasErrors = $form.find('.error').length !== 0;
        if (!formHasErrors) { 
          var expiry = daysBeforeReappear;
          Cookies.set('newsletter-custom-newsletter-modal', 'opened', { path: '/', expires: expiry });
        }
      }, 500);
    });
  }
  
  $(document).ready(function() {
    ProductColorSplit();
    setTimeout(CartPrice, 500);
    
    TileHeights();

    CustomNewsletterModal();
  });
})(jQuery);


/* -------------KIWI SIZING ---------------*/
window.KiwiSizing = window.KiwiSizing === undefined ? {} : window.KiwiSizing;
KiwiSizing.shop = "";






/* Yotpo Product Review Code */
(function e(){var e=document.createElement("script");e.type="text/javascript",e.async=true,e.src="//staticw2.yotpo.com/0sEaGHKcDteRcP7OPg007mOhS7WPM8fuUG4GMAWx/widget.js";var t=document.getElementsByTagName("script")[0];t.parentNode.insertBefore(e,t)})();


